// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_SHOW_MORE_DISCUSSIONS = "Zobraz dal\u0161\u00ed diskuze";
export const FORUM_SIMILAR_DISCUSSIONS = "Podobn\u00e9 diskuze";
